export default __webpack_public_path__ + "1b5bd9e82feed0782cbf2563fae0dedb.png";